window.addEventListener('DOMContentLoaded', (event) => {
  // Show an element
  const showSearch = function (elem) {
    elem.style.display = 'block';
  };

  // Hide an element
  const hideSearch = function (elem) {
    elem.style.display = 'none';
  };

  // define search client
  const searchClient = algoliasearch(
    'RCF41RJMQ2',
    '3a23ccc2ea3c8ae6dfc5c418cfe96632',
  );

  // define instantsearch
  const search = instantsearch({
    indexName: 'shopify_articles',
    searchClient,
    searchFunction(helper) {
      const searchResults = document.getElementById('hitscontainer');
      const noResults = document.getElementById('js-tutorials-no-results');

      if (helper.state.query === '') {
        hideSearch(searchResults);
        noResults.style.display = 'none';
        return;
      }
      helper.search();
      showSearch(searchResults);
      noResults.style.display = 'block';
    },
  });

  // initialize SearchBox
  search.addWidgets([
    instantsearch.widgets.searchBox({
      container: '#searchbox',
      placeholder: 'Search',
    }),

    // restrict results to filtered content
    instantsearch.widgets.configure({
      filters: 'tags:tutorial OR blog.handle:tutorials',
    }),

    // initialize hits widget
    instantsearch.widgets.hits({
      container: '#hitscontainer',
      escapeHits: true,
      transformItems(items) {
        return items.map((item) => {
          // console.log(item);
          return {
            ...item,
            product: item.title.split(' - ')[1],
            brand: item.title.split(' - ')[0],
            title: `${item.title} Tutorial`,
            url: `/blogs/${item.blog.handle}/${item.handle}`,
            img: item.image,
            type: item.blog.title,
            id: item.objectID,
            // parseFirstTitle() {
            //   return function (title) {
            //     return Hogan.compile(title).render(this).split(' - ')[0];
            //   };
            // },
            // parseSecondTitle() {
            //   return function (title) {
            //     const split = Hogan.compile(title).render(this).split(' - ');
            //     return split[split.length - 1];
            //   };
            // },
          };
        });
      },
      templates: {
        empty: 'No results',
        item: ({product, brand, title, url, img, type, id}) =>
          `<div class="pp-search--result" data-hit="hit__${id}"><div class="pp-search--result__image"><a href="${url}" title="${title}"><img src="${img}" /></a></div><div class="pp-search--result__content"><h4><a href="${url}" title="${title}"><span class="pp-search--result__brand">${brand}</span> <span class="pp-search--result__product">${product}</span> <span class="pp-search--result__tutorial">Tutorial</span></a></h4><small>${type}</small></div></div>`,
      },
    }),
  ]);

  search.start();
});
